import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import AuthPageShell from './shared/AuthPageShell';
import PasswordInput from './shared/PasswordInput';
import AuthAlert from './shared/AuthAlert';
import './css/Login.css';

const API_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : '/api');

const OrgResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage('');
    try {
      const res = await axios.post(`${API_URL}/auth/org-reset-password`, { token, newPassword });
      setMessage('Password set. Redirecting to login...');
      setTimeout(
        () => navigate('/org-login', { replace: true, state: { email: res.data.email } }),
        1500
      );
    } catch (err) {
      setMessage(err?.response?.data?.msg || 'Reset failed');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!token) {
    return (
      <AuthPageShell title="Set Your Password">
        <div className="alert alert-danger">Missing reset token. Use the link from your email.</div>
      </AuthPageShell>
    );
  }

  return (
    <AuthPageShell title="Set Your Password">
      <form onSubmit={handleSubmit}>
        <PasswordInput
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Set your password"
          minLength={8}
        />
        <button type="submit" className="btn btn-warning btn-block mt-3" disabled={isSubmitting}>
          {isSubmitting ? 'Saving...' : 'Set password'}
        </button>
        <AuthAlert message={message} variant={message.startsWith('Password set') ? 'success' : 'danger'} />
      </form>
    </AuthPageShell>
  );
};

export default OrgResetPassword;
